export const LOADING_PERSONINFO = 'LOADING_PERSONINFO'
export const GET_PERSONINFO = 'GET_PERSONINFO'
export const GET_ERROR_PERSONINFO = 'GET_ERROR_PERSONINFO'
export const RESET_STATE_PERSON = 'RESET_STATE_PERSON'

export const LOADING_DIRECCIONES = 'LOADING_DIRECCIONES'
export const GET_DIRECCIONES = 'GET_DIRECCIONES'
export const GET_ERROR_DIRECCIONES = 'GET_ERROR_DIRECCIONES'

export const LOADING_TELEFONOS = 'LOADING_TELEFONOS'
export const GET_TELEFONOS = 'GET_TELEFONOS'
export const GET_ERROR_TELEFONOS = 'GET_ERROR_TELEFONOS'

export const LOADING_EMAIL = 'LOADING_EMAIL'
export const GET_EMAIL = 'GET_EMAIL'
export const GET_ERROR_EMAIL = 'GET_ERROR_EMAIL'

export const LOADING_TITULOS = 'LOADING_TITULOS'
export const GET_TITULOS = 'GET_TITULOS'
export const GET_ERROR_TITULOS = 'GET_ERROR_TITULOS'

export const LOADING_PADRES = 'LOADING_PADRES'
export const GET_PADRES = 'GET_PADRES'
export const GET_ERROR_PADRES = 'GET_ERROR_PADRES'

export const LOADING_HIJOS = 'LOADING_HIJOS'
export const GET_HIJOS = 'GET_HIJOS'
export const GET_ERROR_HIJOS = 'GET_ERROR_HIJOS'

export const LOADING_LABORALHISTORICO = 'LOADING_LABORALHISTORICO'
export const GET_LABORALHISTORICO = 'GET_LABORALHISTORICO'
export const GET_ERROR_LABORALHISTORICO = 'GET_ERROR_LABORALHISTORICO'

export const LOADING_CONTRIBUYENTE_IMPUESTOS = 'LOADING_CONTRIBUYENTE_IMPUESTOS'
export const GET_CONTRIBUYENTE_IMPUESTOS = 'GET_CONTRIBUYENTE_IMPUESTOS'
export const GET_ERROR_CONTRIBUYENTE_IMPUESTOS = 'GET_ERROR_CONTRIBUYENTE_IMPUESTOS'

export const LOADING_MECANIZADOGRAFICO = 'LOADING_MECANIZADOGRAFICO'
export const GET_MECANIZADOGRAFICO = 'GET_MECANIZADOGRAFICO'
export const GET_ERROR_MECANIZADOGRAFICO = 'GET_ERROR_MECANIZADOGRAFICO'

export const SET_VALUE = 'SET_VALUE'
export const RESET_VALUE = 'RESET_VALUE'

export const LOADING_MECANIZADO = 'LOADING_MECANIZADO'
export const GET_MECANIZADO = 'GET_MECANIZADO'
export const GET_ERROR_MECANIZADO = 'GET_ERROR_MECANIZADO'

export const LOADING_INVERSIONES = 'LOADING_INVERSIONES'
export const GET_INVERSIONES = 'GET_INVERSIONES'
export const GET_ERROR_INVERSIONES = 'GET_ERROR_INVERSIONES'

export const LOADING_CARGOS_EMPRESARIALES = 'LOADING_CARGOS_EMPRESARIALES'
export const GET_CARGOS_EMPRESARIALES = 'GET_CARGOS_EMPRESARIALES'
export const GET_ERROR_CARGOS_EMPRESARIALES = 'GET_ERROR_CARGOS_EMPRESARIALES'

export const LOADING_BIENESINMUEBLES = 'LOADING_BIENESINMUEBLES'
export const GET_BIENESINMUEBLES = 'GET_BIENESINMUEBLES'
export const GET_ERROR_BIENESINMUEBLES = 'GET_ERROR_BIENESINMUEBLES'

export const LOADING_COGNODATA = 'LOADING_COGNODATA'
export const GET_COGNODATA = 'GET_COGNODATA'
export const GET_ERROR_COGNODATA = 'GET_ERROR_COGNODATA'

export const LOADING_ANTECEDENTES = 'LOADING_ANTECEDENTES'
export const GET_ANTECEDENTES = 'GET_ANTECEDENTES'
export const GET_ERROR_ANTECEDENTES = 'GET_ERROR_ANTECEDENTES'

export const LOADING_DEMANDAOFENDIDO = 'LOADING_DEMANDAOFENDIDO'
export const GET_DEMANDAOFENDIDO = 'GET_DEMANDAOFENDIDO'
export const GET_ERROR_DEMANDAOFENDIDO = 'GET_ERROR_DEMANDAOFENDIDO'

export const LOADING_DEMANDAOFENSOR = 'LOADING_DEMANDAOFENSOR'
export const GET_DEMANDAOFENSOR = 'GET_DEMANDAOFENSOR'
export const GET_ERROR_DEMANDAOFENSOR = 'GET_ERROR_DEMANDAOFENSOR'

export const LOADING_LICENCIA = 'LOADING_LICENCIA'
export const GET_LICENCIA = 'GET_LICENCIA'
export const GET_ERROR_LICENCIA = 'GET_ERROR_LICENCIA'

export const LOADING_VEHICULO = 'LOADING_VEHICULO'
export const GET_VEHICULO = 'GET_VEHICULO'
export const GET_ERROR_VEHICULO = 'GET_ERROR_VEHICULO'

export const LOADING_DENUNCIAS = 'LOADING_DENUNCIAS'
export const GET_DENUNCIAS = 'GET_DENUNCIAS'
export const GET_ERROR_DENUNCIAS = 'GET_ERROR_DENUNCIAS'

export const LOADING_SUPA = 'LOADING_SUPA'
export const GET_SUPA = 'GET_SUPA'
export const GET_ERROR_SUPA = 'GET_ERROR_SUPA'

export const LOADING_LISTACONTROL = 'LOADING_LISTACONTROL'
export const GET_LISTACONTROL = 'GET_LISTACONTROL'
export const GET_ERROR_LISTACONTROL = 'GET_ERROR_LISTACONTROL'

export const LOADING_ANT = 'LOADING_ANT'
export const GET_ANT = 'GET_ANT'
export const GET_ERROR_ANT = 'GET_ERROR_ANT'

export const LOADING_LISTAS_NEGRAS = 'LOADING_LISTAS_NEGRAS'
export const GET_LISTAS_NEGRAS = 'GET_ANT_LISTAS_NEGRAS'
export const GET_ERROR_LISTAS_NEGRAS = 'GET_ERROR_ANT_LISTAS_NEGRAS'

export const LOADING_INFNOMBRE = 'LOADING_INFNOMBRE'
export const GET_INFNOMBRE = 'GET_INFNOMBRE'
export const RESET_SUCCESS = 'RESET_SUCCESS'
export const GET_ERROR_INFNOMBRE = 'GET_ERROR_INFNOMBRE'

export const LOADING_CEDULA = 'LOADING_CEDULA'
export const GET_CEDULACORRECTA = 'GET_CEDULACORRECTA'
export const GET_CEDULAINCORREC = 'GET_CEDULAINCORREC'
export const GET_ERROR_CEDULA = 'GET_ERROR_CEDULA'

export const LOADING_CEDULACOUNT = 'LOADING_CEDULACOUNT'
export const GET_CEDULACOUNT = 'GET_CEDULACOUNT'
export const GET_ERROR_CEDULACOUNT = 'GET_ERROR_CEDULACOUNT'

export const LOADING_DELETECEDULA = 'LOADING_DELETECEDULA'
export const GET_DELETECEDULA = 'GET_DELETECEDULA'
export const GET_ERROR_DELETECEDULA = 'GET_ERROR_DELETECEDULA'

export const LOADING_CREATECEDULA = 'LOADING_CREATECEDULA'
export const GET_CREATECEDULA = 'GET_CREATECEDULA'
export const GET_ERROR_CREATECEDULA = 'GET_ERROR_CREATECEDULA'

export const LOADING_COOPINFO = 'LOADING_COOPINFO'
export const GET_COOPINFO = 'GET_COOPINFO'
export const GET_ERROR_COOPINFO = 'GET_ERROR_COOPINFO'

export const LOADING_DINERSINFO = 'LOADING_DINERSINFO'
export const GET_DINERSINFO = 'GET_DINERSINFO'
export const GET_ERROR_DINERSINFO = 'GET_ERROR_DINERSINFO'

export const LOADING_SUPERINFO = 'LOADING_SUPERINFO'
export const GET_SUPERINFO = 'GET_SUPERINFO'
export const GET_ERROR_SUPERINFO = 'GET_ERROR_SUPERINFO'

export const LOADING_VACUNAINFO = 'LOADING_VACUNAINFO'
export const GET_VACUNAINFO = 'GET_VACUNAINFO'
export const GET_ERROR_VACUNAINFO = 'GET_ERROR_VACUNAINFO'

export const LOADING_ESTABLECIMIENTOINFO = 'LOADING_ESTABLECIMIENTOINFO'
export const GET_ESTABLECIMIENTOINFO = 'GET_ESTABLECIMIENTOINFO'
export const GET_ERROR_ESTABLECIMIENTOINFO = 'GET_ERROR_ESTABLECIMIENTOINFO'

export const LOADING_CONTRIBUYENTEINFO = 'LOADING_CONTRIBUYENTEINFO'
export const GET_CONTRIBUYENTEINFO = 'GET_CONTRIBUYENTEINFO'
export const GET_ERROR_CONTRIBUYENTEINFO = 'GET_ERROR_CONTRIBUYENTEINFO'

export const LOADING_REDIRECT_URL = 'LOADING_REDIRECT_URL'
export const GET_REDIRECT_URL = 'GET_REDIRECT_URL'
export const GET_ERROR_REDIRECT_URL = 'GET_ERROR_REDIRECT_URL'
export const RESET_REDIRECT_URL = 'RESET_REDIRECT_URL'

export const LOADING_EMPRESA_REALM = 'LOADING_EMPRESA_REALM'
export const GET_EMPRESA_REALM = 'GET_EMPRESA_REALM'
export const GET_ERROR_EMPRESA_REALM = 'GET_ERROR_EMPRESA_REALM'

export const LOADING_AFILIACION_ISSPOL = 'LOADING_AFILIACION_ISSPOL'
export const GET_AFILIACION_ISSPOL = 'GET_AFILIACION_ISSPOL'
export const GET_ERROR_AFILIACION_ISSPOL = 'GET_ERROR_AFILIACION_ISSPOL'

export const LOADING_AFILIACION_IESS = 'LOADING_AFILIACION_IESS'
export const GET_AFILIACION_IESS = 'GET_AFILIACION_IESS'
export const GET_ERROR_AFILIACION_IESS = 'GET_ERROR_AFILIACION_IESS'

export const LOADING_AFILIACION_IESS_PDF = 'LOADING_AFILIACION_IESSLOADING_AFILIACION_IESS_PDF'
export const GET_AFILIACION_IESS_PDF = 'GET_AFILIACION_IESSGET_AFILIACION_IESS_PDF'
export const GET_ERROR_AFILIACION_IESS_PDF = 'GET_ERROR_AFILIACION_IESSGET_ERROR_AFILIACION_IESS_PDF'

export const LOADING_AFILIACION_ISSPOL_PDF = 'LOADING_AFILIACION_ISSPOL_PDF'
export const GET_AFILIACION_ISSPOL_PDF = 'GET_AFILIACION_ISSPOL_PDF'
export const GET_ERROR_AFILIACION_ISSPOL_PDF = 'GET_ERROR_AFILIACION_ISSPOL_PDF'

export const LOADING_PENSIONISTA_PDF = 'LOADING_PENSIONISTA_PDF'
export const GET_PENSIONISTA_PDF = 'GET_PENSIONISTA_PDF'
export const GET_ERROR_PENSIONISTA_PDF = 'GET_ERROR_PENSIONISTA_PDF'

export const LOADING_PERSONA_PENSIONISTA = 'LOADING_PERSONA_PENSIONISTA'
export const GET_PERSONA_PENSIONISTA = 'GET_PERSONA_PENSIONISTA'
export const GET_ERROR_PERSONA_PENSIONISTA = 'GET_ERROR_PERSONA_PENSIONISTA'

export const LOADING_DEUDAS_AMT = 'LOADING_DEUDAS_AMT'
export const GET_DEUDAS_AMT = 'GET_DEUDAS_AMT'
export const GET_ERROR_DEUDAS_AMT = 'GET_ERROR_DEUDAS_AMT'

export const LOADING_DEUDAS_EMOV = 'LOADING_DEUDAS_EMOV'
export const GET_DEUDAS_EMOV = 'GET_DEUDAS_EMOV'
export const GET_ERROR_DEUDAS_EMOV = 'GET_ERROR_DEUDAS_EMOV'

export const LOADING_LIST_OFAC = 'LOADING_LIST_OFAC'
export const GET_LIST_OFAC = 'GET_LIST_OFAC'
export const GET_ERROR_LIST_OFAC = 'GET_ERROR_LIST_OFAC'

export const LOADING_FILE_REQUEST = 'LOADING_FILE_REQUEST'
export const GET_FILE_REQUEST = 'GET_FILE_REQUEST'
export const GET_ERROR_FILE_REQUEST = 'GET_ERROR_FILE_REQUEST'
export const RESET_FILE_REQUEST = 'RESET_FILE_UPLOAD'

export const LOADING_FILE_UPLOAD = 'LOADING_FILE_UPLOAD'
export const GET_FILE_UPLOAD = 'GET_FILE_UPLOAD'
export const GET_ERROR_FILE_UPLOAD = 'GET_ERROR_FILE_UPLOAD'

export const LOADING_DEMANDAS_BATCH = 'LOADING_DEMANDAS_BATCH'
export const GET_DEMANDAS_BATCH = 'GET_DEMANDAS_BATCH'
export const GET_ERROR_DEMANDAS_BATCH = 'GET_ERROR_DEMANDAS_BATCH'
export const RESET_DEMANDAS_BATCH = 'RESET_DEMANDAS_BATCH'

export const LOADING_DEMANDAS_BATCH_PROGRESS = 'LOADING_DEMANDAS_BATCH_PROGRESS'
export const GET_DEMANDAS_BATCH_PROGRESS = 'GET_DEMANDAS_BATCH_PROGRESS'
export const GET_ERROR_DEMANDAS_BATCH_PROGRESS = 'GET_ERROR_DEMANDAS_BATCH_PROGRESS'
export const RESET_PROGRESS = 'RESET_PROGRESS'

export const LOADING_DOWNLOAD_ACTIVITY_REQUEST = 'LOADING_DOWNLOAD_ACTIVITY_REQUEST'
export const GET_DOWNLOAD_ACTIVITY_REQUEST = 'GET_DOWNLOAD_ACTIVITY_REQUEST'
export const GET_ERROR_DOWNLOAD_ACTIVITY_REQUEST = 'GET_ERROR_DOWNLOAD_ACTIVITY_REQUEST'
export const LOADING_AFILIACION_ISSFAC_MEDICO = 'LOADING_AFILIACION_ISSFAC_MEDICO'
export const GET_AFILIACION_ISSFAC_MEDICO = 'GET_AFILIACION_ISSFAC_MEDICO'
export const GET_ERROR_AFILIACION_ISSFAC_MEDICO = 'GET_ERROR_AFILIACION_ISSFAC_MEDICO'

export const LOADING_AFILIACION_ISSFAC_FUERZA_ARMADA = 'LOADING_AFILIACION_ISSFAC_FUERZA_ARMADA'
export const GET_AFILIACION_ISSFAC_FUERZA_ARMADA = 'GET_AFILIACION_ISSFAC_FUERZA_ARMADA'
export const GET_ERROR_AFILIACION_ISSFAC_FUERZA_ARMADA = 'GET_ERROR_AFILIACION_ISSFAC_FUERZA_ARMADA'

export const LOADING_AFILIACION_CUMPLIMIENTO_PATRONAL = 'LOADING_AFILIACION_CUMPLIMIENTO_PATRONAL'
export const GET_AFILIACION_CUMPLIMIENTO_PATRONAL = 'GET_AFILIACION_CUMPLIMIENTO_PATRONAL'
export const GET_ERROR_AFILIACION_CUMPLIMIENTO_PATRONAL = 'GET_ERROR_AFILIACION_CUMPLIMIENTO_PATRONAL'

export const LOADING_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF = 'LOADING_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF'
export const GET_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF = 'GET_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF'
export const GET_ERROR_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF = 'GET_ERROR_AFILIACION_CUMPLIMIENTO_PATRONAL_PDF'

export const LOADING_AFILIACION_SIISPOL = 'LOADING_AFILIACION_SIISPOL'
export const GET_AFILIACION_SIISPOL = 'GET_AFILIACION_SIISPOL'
export const GET_ERROR_AFILIACION_SIISPOL = 'GET_ERROR_AFILIACION_SIISPOL'

export const LOADING_AFILIACION_SIISPOL_PDF = 'LOADING_AFILIACION_SIISPOL_PDF'
export const GET_AFILIACION_SIISPOL_PDF = 'GET_AFILIACION_SIISPOL_PDF'
export const GET_ERROR_AFILIACION_SIISPOL_PDF = 'GET_ERROR_AFILIACION_SIISPOL_PDF'

export const LOADING_SININIESTROS = 'LOADING_SININIESTROS'
export const GET_SININIESTROS = 'GET_SININIESTROS'
export const GET_ERROR_SININIESTROS = 'GET_ERROR_SININIESTROS'

export const LOADING_SUPERINTENDENCIA_DEUDORES = 'LOADING_SUPERINTENDENCIA_DEUDORES'
export const GET_SUPERINTENDENCIA_DEUDORES = 'GET_SUPERINTENDENCIA_DEUDORES'
export const GET_ERROR_SUPERINTENDENCIA_DEUDORES = 'GET_ERROR_SUPERINTENDENCIA_DEUDORES'

export const LOADING_PERSONA_EMPLEADOS = 'LOADING_PERSONA_EMPLEADOS'
export const GET_PERSONA_EMPLEADOS = 'GET_PERSONA_EMPLEADOS'
export const GET_ERROR_PERSONA_EMPLEADOS = 'GET_ERROR_PERSONA_EMPLEADOS'

export const LOADING_CREDITO_HIPOTECARIO = 'LOADING_CREDITO_HIPOTECARIO'
export const GET_CREDITO_HIPOTECARIO = 'GET_CREDITO_HIPOTECARIO'
export const GET_ERROR_CREDITO_HIPOTECARIO = 'GET_ERROR_CREDITO_HIPOTECARIO'

export const LOADING_CREDITO_QUIROGRAFARIO = 'LOADING_CREDITO_QUIROGRAFARIO'
export const GET_CREDITO_QUIROGRAFARIO = 'GET_CREDITO_QUIROGRAFARIO'
export const GET_ERROR_CREDITO_QUIROGRAFARIO = 'GET_ERROR_CREDITO_QUIROGRAFARIO'

export const LOADING_POLIZAS = 'LOADING_POLIZAS'
export const GET_POLIZAS = 'GET_POLIZAS'
export const GET_ERROR_POLIZAS = 'GET_ERROR_POLIZAS'

export const LOADING_COBERTURA_SALUD = 'LOADING_COBERTURA_SALUD'
export const GET_COBERTURA_SALUD = 'GET_COBERTURA_SALUD'
export const GET_ERROR_COBERTURA_SALUD = 'GET_ERROR_COBERTURA_SALUD'

export const LOADING_HISTORY_MASIVE = 'LOADING_HISTORY_MASIVE'
export const GET_HISTORY_MASIVE = 'GET_HISTORY_MASIVE'
export const GET_ERROR_HISTORY_MASIVE = 'GET_ERROR_HISTORY_MASIVE'

export const LOADING_ERROR_DOCUMENT_MASIVE = 'LOADING_ERROR_DOCUMENT_MASIVE'
export const GET_DOCUMENT_ERROR_MASIVE = 'GET_DOCUMENT_ERROR_MASIVE'
export const GET_FAILED_ERROR_DOCUMENT_MASIVE = 'GET_FAILED_ERROR_DOCUMENT_MASIVE'

export const LOADING_COUNT_PROCESS_MASIVE = 'LOADING_COUNT_PROCESS_MASIVE'
export const GET_COUNT_PROCESS_MASIVE = 'GET_COUNT_PROCESS_MASIVE'
export const GET_ERROR_COUNT_PROCESS_MASIVE = 'GET_ERROR_COUNT_PROCESS_MASIVE'
export const RESET_COUNT_PROCESS_MASIVE = 'RESET_COUNT_PROCESS_MASIVE'

export const LOADING_USER_REALM = 'LOADING_USER_REALM'
export const GET_USER_REALM = 'GET_USER_REALM'
export const GET_ERROR_USER_REALM = 'GET_ERROR_USER_REALM'
export const RESET_USER_REALM = 'RESET_USER_REALM'

export const LOADING_DOWNLOAD_REPORT_CONSULT = 'LOADING_DOWNLOAD_REPORT_CONSULT'
export const GET_DOWNLOAD_REPORT_CONSULT = 'GET_DOWNLOAD_REPORT_CONSULT'
export const GET_ERROR_DOWNLOAD_REPORT_CONSULT = 'GET_ERROR_DOWNLOAD_REPORT_CONSULT'
export const RESET_DOWNLOAD_REPORT_CONSULT = 'RESET_DOWNLOAD_REPORT_CONSULT'

export const LOADING_RETIRED_PERSON = 'LOADING_RETIRED_PERSON'
export const GET_RETIRED_PERSON = 'GET_RETIRED_PERSON'
export const GET_ERROR_RETIRED_PERSON = 'GET_ERROR_RETIRED_PERSON'

export const LOADING_RETAILS_PERSON = 'LOADING_RETAILS_PERSON'
export const GET_RETAILS_PERSON = 'GET_RETAILS_PERSON'
export const GET_ERROR_RETAILS_PERSON = 'GET_ERROR_RETAILS_PERSON'

export const LOADING_VEHICLE_CONDITION = 'LOADING_VEHICLE_CONDITION'
export const GET_VEHICLE_CONDITION = 'GET_VEHICLE_CONDITION'
export const GET_ERROR_VEHICLE_CONDITION = 'GET_ERROR_VEHICLE_CONDITION'

export const LOADING_CUSTOMER_PAYMENT_BEHAVIOR = 'LOADING_CUSTOMER_PAYMENT_BEHAVIOR'
export const GET_CUSTOMER_PAYMENT_BEHAVIOR = 'GET_CUSTOMER_PAYMENT_BEHAVIOR'
export const GET_ERROR_CUSTOMER_PAYMENT_BEHAVIOR = 'GET_ERROR_CUSTOMER_PAYMENT_BEHAVIOR'

export const LOADING_SUPA_NOVADATA = 'LOADING_SUPA_NOVADATA'
export const GET_SUPA_NOVADATA = 'GET_SUPA_NOVADATA'
export const GET_ERROR_SUPA_NOVADATA = 'GET_ERROR_SUPA_NOVADATA'

export const LOADING_SRI_IMPUESTOS = 'LOADING_SRI_IMPUESTOS'
export const GET_SRI_IMPUESTOS = 'GET_SRI_IMPUESTOS'
export const GET_ERROR_SRI_IMPUESTOS = 'GET_ERROR_SRI_IMPUESTOS'

export const LOADING_IMPEDIMENTO_CARGOS = 'LOADING_IMPEDIMENTO_CARGOS'
export const GET_IMPEDIMENTO_CARGOS = 'GET_IMPEDIMENTO_CARGOS'
export const GET_ERROR_IMPEDIMENTO_CARGOS = 'GET_ERROR_IMPEDIMENTO_CARGOS'

export const LOADING_IMPEDIMENTO_CARGOS_PDF = 'LOADING_IMPEDIMENTO_CARGOS_PDF'
export const GET_IMPEDIMENTO_CARGOS_PDF = 'GET_IMPEDIMENTO_CARGOS_PDF'
export const GET_ERROR_IMPEDIMENTO_CARGOS_PDF = 'GET_ERROR_IMPEDIMENTO_CARGOS_PDF'

export const LOADING_SERCOP = 'LOADING_SERCOP'
export const GET_SERCOP = 'GET_SERCOP'
export const GET_ERROR_SERCOP = 'GET_ERROR_SERCOP'
